
import Vue from 'vue'
import updateManOrg from '@/connectors/managing-organization/update-managing-organization'
import { userGetInfo } from '@/connectors/user'
import showManOrg from '@/connectors/managing-organization/show-managing-organization'
import Loader from '@/components/Loader.vue'
import { IManagingOrganization } from '@/types/user'

export default Vue.extend({
  name: 'ContractWizard',
  components: { Loader },
  data () {
    return {
      loader: false,
      managingOrganization: {} as IManagingOrganization
    }
  },
  mounted () {
    this.showManagingOrganization()
  },
  methods: {
    showManagingOrganization () {
      this.loader = true
      showManOrg(Number(localStorage.getItem('moid')), 0, 0)
        .then(response => {
          console.log('managingTSG', response)
          this.managingOrganization = response
          this.loader = false
        }).catch(e => {
          this.loader = false
          console.error(e)
          // @ts-ignore
          this.$showErrorToast(e.message)
        })
    },
    updateMO () {
      if (localStorage.getItem('moid')) {
        this.managingOrganization.systemSite = undefined
        this.managingOrganization.connectedToSystem = 1
        updateManOrg(Number(localStorage.getItem('moid')), this.managingOrganization)
          .then((res) => {
            userGetInfo().then((response) => {
              this.$store.dispatch('profile/setUser', response)
              this.$store.dispatch('profile/selectOrganization', 0)
            }).then(() => (this.$router.push('/app/end_wizard')))
            this.$store.dispatch('profile/addItemOrganization', { text: res.shortName, id: res.id })
          }).catch((e) => {
            console.error(e.response, 'err')
            if (e.response.status === 403) {
            // @ts-ignore
              this.$showErrorToast(e.response.data.message)
            } else {
              console.error(e.response)
              // @ts-ignore
              this.$showErrorToast(e.response.data.message)
            }
          })
      }
    }
  }
})
